import React from "react";
import PropTypes from "prop-types";

import { TextButton } from "components/core/Button";
import { H4 } from "components/core/Typography";

export const AdditionalNameInputsGroupV2 = ({ handleRemoveName, children }) => (
	<div className="additional-names-inputs-group">
		<H4 className="additional-names-heading">Additional User</H4>
		<div className="additional-name-inputs">{children}</div>
		<TextButton
			color="blue"
			flush
			fullWidth={false}
			onClick={handleRemoveName}
			className="remove-name-button"
		>
			Remove Name
		</TextButton>
	</div>
);

AdditionalNameInputsGroupV2.propTypes = {
	children: PropTypes.node.isRequired,
	handleRemoveName: PropTypes.func.isRequired
};
